import { Box, Container, Link, Typography } from '@mui/material'
import React from 'react'

export default function PrivacyPolicy() {
  return (
    <Container sx={{bgcolor: 'background.default'}}>
      <Box>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          プライバシーポリシー
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Rating for MasterDuel（以下、「当サイト」と言います。）では、ご利用者様からお預かりする個人情報の重要性を強く認識し、個人情報の保護に関する法律、その他の関係法令を遵守すると共に、以下に定めるプライバシーポリシーに従って、個人情報を安全かつ適切に取り扱うことを宣言いたします。
        </Typography>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          個人情報とは
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          本プライバシーポリシーにおいて、個人情報とは生存する個人に関する情報であって、氏名、生年月日、住所、電話番号、メールアドレス等、特定の個人を識別することができるものをいいます。
        </Typography>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          個人情報の利用目的
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Googleが提供するアプリケーション開発プラットフォームのFirebaseを通して、ユーザーの認証に利用します。
        </Typography>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          個人情報の第三者提供について
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          当サイトは個人情報を、個人情報保護法その他の法令に基づき開示が認められる場合を除き、ご本人様の同意を得ずに第三者に提供することはありません。
        </Typography>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          Cookieについて
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          当サイトでは、第三者配信事業者である「Googleアドセンス」を利用しておりますが、Cookieを使用することにより、ご利用者様の過去のアクセス情報に基づいて、適切な広告を配信する場合があります。
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          ご利用者様は{<Link href='https://adssettings.google.com/authenticated' target='_blank'>Google広告設定</Link>}から、Cookieを使用したパーソナライズ広告を無効にすることができます。なお、Cookieに保存されている情報からご利用者様個人を特定することはできません。
        </Typography>
        <Typography variant='subtitle1' sx={{mt: 1}}>
          本ポリシーの変更について
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          当サイトは、法令の制定、改正や、提供するサービスの拡充により、本ポリシーを適宜見直し、予告なく変更する場合があります。
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          本ポリシーを変更した場合には{<Link href='https://twitter.com/RforMD' target='_blank'>公式のTwitterアカウント</Link>}から告知を行います。
        </Typography>
      </Box>
    </Container>
  )
}